import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  BodyHeader,
  CompareFilterMultiselectCont,
  SearchCont,
  TileListCont,
} from './CompareFilterMultiselect.styles';
import { CaptionBoldL } from '../../../../styles/globals';
import NoData from '../../../NoData/NoData';
import SearchSimpleInput from '../../../SearchSimpleInput/SearchSimpleInput';
import { IFilterMultiselectDataEl } from '../../CompareSortFilter';
import CompareFilterTile from '../CompareFilterTile/CompareFilterTile';

interface ICompareFilterMultiselect {
  searchMethod?: (phrase: string) => void;
  name: string;
  data: IFilterMultiselectDataEl[];
  setSelected: (val: string) => void;
  selectedArr: string[];
}

const CompareFilterMultiselect: FC<ICompareFilterMultiselect> = ({
  searchMethod,
  setSelected,
  data,
  name,
  selectedArr,
}) => {
  const { t } = useTranslation();
  const renderBodyTile = useMemo(() => {
    return data?.map((tileVal: IFilterMultiselectDataEl, index: number) => {
      const isSelected = selectedArr?.includes(tileVal.id) || false;
      return (
        index < 6 && (
          <CompareFilterTile
            key={tileVal.id}
            data={tileVal}
            setSelected={setSelected}
            selected={isSelected}
          />
        )
      );
    });
  }, [data, selectedArr, setSelected]);

  return (
    <CompareFilterMultiselectCont id="CompareFilterMultiselectCont">
      <BodyHeader id="BodyHeader">
        <CaptionBoldL id="CaptionBoldL">{name}</CaptionBoldL>
      </BodyHeader>
      {!!searchMethod && (
        <SearchCont id="SearchCont">
          <SearchSimpleInput
            data-testid="SearchSimpleInput"
            doSearch={searchMethod}
            placeholder={t('reports.search')}
          />
        </SearchCont>
      )}
      <TileListCont id="TileListCont">
        {data.length > 0 ? (
          renderBodyTile
        ) : (
          <NoData height="100px" message={t('report.groupComparison.noData')} />
        )}
      </TileListCont>
    </CompareFilterMultiselectCont>
  );
};

export default CompareFilterMultiselect;
